import useMoney from '../../../hooks/useMoney';
import LangEnum from '../../../lang/LangEnum';
import { TeceoApiResponse } from '../../../lib/basicRepository';
import snackbarStore from '../../../stores/Snackbar.store';
import { useTranslation } from '../../translation/TranslationContext';
import { transformUpdateResponse } from '../ordersUtils';

const { handleMessage } = snackbarStore;

const useHandleErrorOnChangingOrderStatus = () => {
  const { translate } = useTranslation();
  const { getCurrencySymbol, formatMoney } = useMoney();

  const handleError = (response: TeceoApiResponse<unknown>) => {
    if (response.ok) {
      return;
    }

    if (response?.data?.message && Array.isArray(response?.data?.message)) {
      const message = transformUpdateResponse(
        response.data.message,
        formatMoney,
        translate,
        getCurrencySymbol(),
      );
      handleMessage({ type: 'error', message });
      return;
    }

    const translation =
      response?.data?.code && translate(response?.data?.code as LangEnum, response?.data?.data);

    handleMessage({ type: 'error', message: translation || response?.data?.message });
  };

  return {
    handleError,
  };
};

export default useHandleErrorOnChangingOrderStatus;
